import { bwDarkTheme, bwLightTheme } from "react-admin";
import { deepmerge } from "@mui/utils";
import type { ThemeOptions } from "@mui/material/styles";
import {
  readBrandingStorageFingerprint,
  readStoredTenantBrandingTheme,
} from "@/utils/tenant-branding-cache";
import { mergeTenantBrandedThemes } from "@/theme/mergeTenantThemeOptions";
import { tableZebraThemeFragment } from "@/theme/tableZebraTheme";
import { withArabicDisplayFont } from "@/theme/withArabicDisplayFont";

type BrandedThemes = { light: ThemeOptions; dark: ThemeOptions };

let cachedFingerprint = "";
let cachedThemes: BrandedThemes | null = null;

function computeBrandedThemeOptions(): BrandedThemes {
  const m = mergeTenantBrandedThemes(bwLightTheme, bwDarkTheme, readStoredTenantBrandingTheme());
  return {
    light: withArabicDisplayFont(deepmerge(m.light, tableZebraThemeFragment) as ThemeOptions),
    dark: withArabicDisplayFont(deepmerge(m.dark, tableZebraThemeFragment) as ThemeOptions),
  };
}

/**
 * Light/dark theme options passed to `<Admin theme={…} />`, after tenant `themeOptions`
 * from sessionStorage and table zebra striping — same merge as {@link useTenantBrandedThemes}.
 */
export function getBrandedThemeOptions(): BrandedThemes {
  const fingerprint = readBrandingStorageFingerprint();
  if (cachedThemes && fingerprint === cachedFingerprint) {
    return cachedThemes;
  }
  cachedFingerprint = fingerprint;
  cachedThemes = computeBrandedThemeOptions();
  return cachedThemes;
}
